// extracted by mini-css-extract-plugin
var _1 = "awDT8";
var _2 = "u_ifH";
var _3 = "dA4rF";
var _4 = "gHcBW";
export { _1 as "name", _2 as "project", _3 as "selected", _4 as "version" }
